import React from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../resources/strings/StringKeys';

export const LANGUAGE_OPTIONS = [
  { value: 'da', flag: '🇩🇰', labelKey: StringKeys.DANISH },
  { value: 'en-US', flag: '🇺🇸', labelKey: StringKeys.ENGLISH },
  { value: 'fi', flag: '🇫🇮', labelKey: StringKeys.FINNISH },
  { value: 'fra', flag: '🇫🇷', labelKey: StringKeys.FRENCH },
  { value: 'deu', flag: '🇩🇪', labelKey: StringKeys.GERMAN },
  { value: 'el', flag: '🇬🇷', labelKey: StringKeys.GREEK },
  { value: 'it', flag: '🇮🇹', labelKey: StringKeys.ITALIAN },
  { value: 'nb', flag: '🇳🇴', labelKey: StringKeys.NORWEGIAN },
  { value: 'pl', flag: '🇵🇱', labelKey: StringKeys.POLISH },
  { value: 'pt', flag: '🇵🇹', labelKey: StringKeys.PORTUGUESE },
  { value: 'es', flag: '🇪🇸', labelKey: StringKeys.SPANISH },
  { value: 'sv-SE', flag: '🇸🇪', labelKey: StringKeys.SWEDISH },
];

export const LanguageSelector = ({
  value,
  onChange,
  size = 'small',
  fullWidth = true,
  sx = {},
  displayEmpty = false,
}) => {
  const { t } = useTranslation();

  return (
    <FormControl fullWidth={fullWidth} size={size}>
      <Select
        value={value}
        onChange={onChange}
        displayEmpty={displayEmpty}
        sx={sx}
      >
        {LANGUAGE_OPTIONS.map((lang) => (
          <MenuItem key={lang.value} value={lang.value}>
            {lang.flag} {t(lang.labelKey)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSelector;
